export default "__VITE_ASSET__CdM7cDbg__"